import { render, staticRenderFns } from "./Cares.vue?vue&type=template&id=426dc6e3&scoped=true&"
import script from "./Cares.vue?vue&type=script&lang=js&"
export * from "./Cares.vue?vue&type=script&lang=js&"
import style0 from "./Cares.vue?vue&type=style&index=0&id=426dc6e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426dc6e3",
  null
  
)

export default component.exports